(function () {
  var MOBILE_MQL = window.matchMedia('(max-width: 989px)');

  function slideCount(splideRoot) {
    var list = splideRoot.querySelector('.splide__list');
    if (!list) return 0;
    return list.children.length;
  }

  function initPdpRecoSliders(root) {
    if (typeof window.makeSlideshow !== 'function') return;
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.pdp-reco-slider.splide').forEach(function (splideRoot) {
      if (!splideRoot.id) return;
      if (slideCount(splideRoot) === 0) {
        if (window.slideshows && window.slideshows[splideRoot.id] && typeof window.destroySlideshow === 'function') {
          window.destroySlideshow(splideRoot);
          splideRoot.classList.remove('is-initialized', 'is-active');
        }
        return;
      }

      if (window.slideshows && window.slideshows[splideRoot.id]) {
        if (typeof window.destroySlideshow === 'function') {
          window.destroySlideshow(splideRoot);
        }
        splideRoot.classList.remove(
          'is-initialized',
          'is-active',
          'splide--slide',
          'splide--ltr',
          'splide--draggable'
        );
      }

      window.makeSlideshow(splideRoot);
    });
  }

  window.initPdpRecoSliders = initPdpRecoSliders;

  function ensureMakeSlideshowPatched() {
    if (window.__pdpRecoMakeSlideshowPatched) return;
    if (typeof window.makeSlideshow !== 'function') return;
    patchMakeSlideshow();
  }

  function patchMakeSlideshow() {
    if (!window.makeSlideshow || window.__pdpRecoMakeSlideshowPatched) return;
    var original = window.makeSlideshow;
    window.makeSlideshow = function (splideRoot) {
      if (
        splideRoot &&
        splideRoot.matches &&
        splideRoot.matches('.pdp-reco-slider') &&
        slideCount(splideRoot) === 0
      ) {
        return;
      }
      return original.call(this, splideRoot);
    };
    window.__pdpRecoMakeSlideshowPatched = true;
  }

  function initOtherSlideshows(root) {
    if (typeof window.discoverNewSlideshows !== 'function') return;
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.splide').forEach(function (splideRoot) {
      if (splideRoot.matches('.pdp-reco-slider')) return;
      window.makeSlideshow(splideRoot);
    });
  }

  function boot(root) {
    ensureMakeSlideshowPatched();
    initPdpRecoSliders(root || document);
    initOtherSlideshows(root || document);
  }

  function scheduleBoot(root) {
    ensureMakeSlideshowPatched();
    if (typeof window.makeSlideshow === 'function') {
      boot(root);
      return;
    }
    document.addEventListener(
      'DOMContentLoaded',
      function onReady() {
        document.removeEventListener('DOMContentLoaded', onReady);
        boot(root);
      },
      { once: true }
    );
  }

  ensureMakeSlideshowPatched();
  if (typeof window.makeSlideshow !== 'function') {
    document.addEventListener('DOMContentLoaded', ensureMakeSlideshowPatched, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleBoot(document);
    });
  } else {
    scheduleBoot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) scheduleBoot(event.target);
  });

  var pending = false;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      var needsInit = document.querySelector(
        '.pdp-reco-slider.splide:not(.is-active) .splide__list > *'
      );
      if (needsInit && MOBILE_MQL.matches) {
        initPdpRecoSliders(document);
      }
      var meetTheShades = document.querySelector(
        '.meet-the-shades__slider.splide:not(.is-initialized)'
      );
      if (meetTheShades && typeof window.discoverNewSlideshows === 'function') {
        window.discoverNewSlideshows(document);
      }
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
